// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Restricted_wrapper__1LS-t","buttonsRow":"Restricted_buttonsRow__WsnNp"};